import React from 'react';
import { Stack, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  FileDownload as FileDownloadIcon,
  FileUpload as FileUploadIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { pagePaths } from 'routes/paths';
import FilledActionButton from 'components/FilledActionButton';

// Navigating via `onClick` + `useNavigate` rather than `component={Link}`
// so the button renders as a real <button> element. With Link the theme's
// CssBaseline rule `a { color: inherit }` collides with the contained
// variant override and the label loses its white colour until hovered.
const PortActions: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  // On narrow viewports we collapse to icon-only to keep the header row compact.
  const compact = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stack direction={'row'} spacing={1}>
      <FilledActionButton
        onClick={() => navigate('/' + pagePaths.vocabularyImport)}
        startIcon={<FileUploadIcon sx={{ fontSize: 18 }} />}
        sx={
          compact ? { '& .MuiButton-startIcon': { marginRight: 0 } } : undefined
        }
      >
        {compact ? '' : 'Імпорт'}
      </FilledActionButton>
      <FilledActionButton
        onClick={() => navigate('/' + pagePaths.vocabularyExport)}
        startIcon={<FileDownloadIcon sx={{ fontSize: 18 }} />}
        sx={
          compact ? { '& .MuiButton-startIcon': { marginRight: 0 } } : undefined
        }
      >
        {compact ? '' : 'Експорт'}
      </FilledActionButton>
    </Stack>
  );
};

export default PortActions;
